module.exports = __webpack_public_path__ + "img/du_landscape.a3c96ccd.jpg";